export default "__VITE_ASSET__CpLinQX2__"